import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: window.location.origin + "/api/",
});
export const axiosWithoutAuth = axios.create({
  baseURL: window.location.origin + "/api/",
});

axiosInstance.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      sessionStorage.setItem("IsSessionTimeout", false);
    } else if (res.status === 302) {
      return false;
    }

    if (res.data?.status === "Failure") {
      sessionStorage.setItem("pUrl", window.location.pathname);

      if (String(window.location.pathname).includes("/tilpaymentpayment")) {
        sessionStorage.setItem("IsSessionTimeout", false);
        return res;
      } else {
        return false;
      }
    } else {
      return res;
    }
  },
  (err) => {
    if (axios.isCancel(err) || err?.code === "ERR_CANCELED") {
      return Promise.reject(err);
    }

    if (err?.response?.status === 401) {
      setSessionTimeout();
      if (err?.response?.data?.title === "Unauthorized") {
        setSessionTimeout();
      }
    }

    return Promise.reject(err);
  },
);

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = token;
    }

    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => Promise.reject(error),
);

export default function setToken() {
  const jwtToken = sessionStorage.getItem("Token");
  if (!jwtToken) {
    delete axios.defaults.headers.common["Authorization"];
  }
}

export function setSessionTimeout() {
  const logoutEvent = new CustomEvent("logoutReactFunction");
  window.dispatchEvent(logoutEvent);
  return false;
}

function getToken() {
  const jwtToken = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
  if (jwtToken) {
    return `Bearer ${jwtToken}`;
  } else {
    return null;
  }
}
//}

//function getToken() {
//  const jwtToken = sessionStorage.getItem("Token");
//  if (jwtToken) {
//    return `Bearer ${jwtToken}`;
//  } else {
//    return `Bearer `;
//  }
//}
